document.addEventListener('DOMContentLoaded', function () {



  
   if (window.innerWidth < 768) {
    const header = document.querySelector('.selected-items');
    const wrapper = document.querySelector('.selected-product-wrapper');
    document.querySelector('.selected-items .h3-title').textContent = "Show Selected Items";
    header.addEventListener('click', function() {
        wrapper.classList.toggle('expanded');
        document.querySelector('.selected-items').classList.toggle('expanded');
    });
  }else{
    document.querySelector('.selected-items .h3-title').textContent = "Selected Items";

  }

  // Primary slider
  // ACCCESSORY POPUP SLIDER
  var primary_slider = document.getElementsByClassName('primary_slider');
  var thumbnail_slider = document.getElementsByClassName('thumbnail_slider');

  for (var i = 0; i < primary_slider.length; i++) {
    var primary_slider_elm = new Splide(primary_slider[i], {
      type: 'fade',
      heightRatio: 0.5,
      pagination: false,
      arrows: true,
      cover: false,
      rewind: true,
    });

    var thumbnail_slider_elm = new Splide(thumbnail_slider[i], {
      rewind: true,
      fixedWidth: 100,
      fixedHeight: 64,
      isNavigation: true,
      gap: 10,
      arrows: false,
      pagination: true,
      focus: 'center',
      cover: true,
      breakpoints: {
        '600': {
          fixedWidth: 66,
          fixedHeight: 40,
        }
      }
    }).mount();;
    primary_slider_elm.sync(thumbnail_slider_elm).mount();

  }

  // Function to add a product ensuring only one product_1 exists
  function addProductToSelectedProductsObject(variantId, variantPrice, type) {
    if (type != "accessories") {
      for (const key in selectedProducts) {
        if (selectedProducts[key].type === type) {
          // Delete the existing product_1 entry
          delete selectedProducts[key];
          break; // Exit loop since we only need to remove one
        }
      }
    } else {
      for (const key in selectedProducts) {
        if (selectedProducts[key] === variantId) {
          // Delete the existing product_1 entry
          delete selectedProducts[key];
          break; // Exit loop since we only need to remove one
        }
      }
    }


    // Add the new product
    selectedProducts[variantId] = {
      "variantId": variantId,
      "variantPrice": variantPrice,
      "type": type
    };
  }

  // FILTER VARIANT COLORS ONCE VARIANT SIZE IS CLICKED
  document.querySelectorAll(".variant-option").forEach((option) => {
    option.addEventListener("click", function () {

      // Remove .selected class from all options
      document.querySelectorAll(".variant-option").forEach((el) => el.classList.remove("selected"));

      // Add .selected class to the clicked option
      this.classList.add("selected");

      const colorThumbnails = this.closest(".color-thumbnails");

      const selectedSize = this.getAttribute("size");
      colorThumbnails.setAttribute("selected-size", selectedSize);

      // Get all thumbnail__item elements within the colorThumbnails parent
      const thumbnailItems = colorThumbnails.querySelectorAll(".thumbnail__item");
      // Show/hide thumbnails based on the selected size
      var clicked = 0;

      thumbnailItems.forEach((thumbnail, index) => {
        const variantSize = thumbnail.getAttribute("variant-size");
        if (variantSize === selectedSize) {
          if (clicked == 0) {
            thumbnail.click();
            clicked = 1;
          }
          thumbnail.classList.remove("d-none"); // Show matching size
        } else {
          thumbnail.classList.add("d-none"); // Hide non-matching sizes
        }
      });
    });
  });


  function updateTotalValues(data) {
    // Select elements by their IDs within the .total-wrapper container
    const subtotalElement = document.getElementById('subtotal_amount');
    const shippingElement = document.getElementById('shipping_amount');
    const discountElement = document.getElementById('discount_amount');
    const totalElement = document.getElementById('total_amount');

    // Update each element's text content based on the input data object
    if (subtotalElement && data.subtotal !== undefined) {
      subtotalElement.textContent = `$${data.subtotal}`;
    }
    if (shippingElement && data.shipping !== undefined) {
      shippingElement.textContent = `$${data.shipping}`;
    }
    if (discountElement && data.discount !== undefined) {
      discountElement.textContent = `-$${data.discount}`;
    }
    if (totalElement && data.total !== undefined) {
      totalElement.textContent = `$${data.total}`;
    }
  }

  function getSelectedProductDetails() {
    // Select the main wrapper
    const wrapper = document.querySelector('.selected-product-wrapper');
    if (!wrapper) return null;

    // Helper function to extract data from a single product card
    function extractData(element) {
      return {
        variantId: element.getAttribute('data-variant-id'),
        title: element.querySelector('#product-title')?.textContent || '',
        color: element.querySelector('#variant-color')?.textContent || '',
        size: element.querySelector('#variant-size')?.textContent || '',
        price: element.querySelector('#variant-price')?.textContent || '',
        image: element.querySelector('img')?.src || '',
        type: "products"
      };
    } // extractData()

    // Get the elements and extract data for each card
    const productDetails = {
      card1: extractData(wrapper.querySelector('#selected-product-card-1')),
      card2: extractData(wrapper.querySelector('#selected-product-card-2')),
      accessories: []
    };


    // Get all accessory cards and extract their details
    const accessoryCards = wrapper.querySelectorAll('.selected-product-card.accessories');
    accessoryCards.forEach(card => {
      const accessoryData = {
        variantId: card.getAttribute('data-variant-id') || '',
        title: card.querySelector('#product-title')?.textContent || '',
        price: card.querySelector('#accessory-price')?.textContent || '',
        color: card.querySelector('#accessory-colour')?.textContent || '',
        size: card.querySelector('#accessory-size')?.textContent || '',
        image: card.querySelector('.selected__item-image')?.src || '',
        type: "accessories"
      };
      if (card.getAttribute('data-variant-id') !== '') {
        productDetails.accessories.push(accessoryData);
      }
    });
    // Populate `selectedProducts` with normalized data

    return productDetails;

  } //getSelectedProductDetails()

  // Loop through each product section (1 to 6)
  for (let i = 1; i <= 6; i++) {

    const productSection = document.querySelector(`#featured-product-section-${i}`);
    if (i <= 3) {
      productSection.setAttribute('data-step', '1');
    } else {
      productSection.setAttribute('data-step', '2');
    }
    const parentSection = productSection.parentElement;
    // Select the modal body where the product section should be copied

    const modalBody = document.querySelector(`.modal-product-${i} .modal__body`);
    // Check if both the product section and modal body exist

    if (parentSection && modalBody) {
      const productClone = parentSection.cloneNode(true);
      productClone.classList.remove('d-none');
      modalBody.appendChild(productClone);
      parentSection.remove();
    }
  }

  // Function to open the modal
  const openModal = (modalId) => {
    const modal = document.querySelector(`.${modalId}`);
    if (modal) {
      modal.setAttribute('aria-hidden', 'false');
      modal.style.display = 'flex'; // Show the modal
      document.body.style.overflow = 'hidden'; // Prevent scrolling
    }
  };

  // Function to close the modal
  const closeModal = (modalId) => {
    const modal = document.querySelector(`.${modalId}`);
    if (modal) {
      modal.setAttribute('aria-hidden', 'true');
      modal.style.display = 'none'; // Hide the modal
      document.body.style.overflow = ''; // Allow scrolling
    }
  };

  // Event listener for opening modals
  document.querySelectorAll('[data-micromodal-trigger]').forEach((button) => {
    button.addEventListener('click', (event) => {
      const modalId = event.currentTarget.getAttribute('data-micromodal-trigger');
      openModal(modalId);
    });
  });

  // Event listener for closing modals
  document.querySelectorAll('[data-micromodal-close]').forEach((closeButton) => {
    closeButton.addEventListener('click', (event) => {
      const modalId = event.currentTarget.closest('.micromodal').classList[0];
      closeModal(modalId);
    });
  });

  // Event listener for closing modals on backdrop click
  document.querySelectorAll('.micromodal').forEach((modal) => {
    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        const modalId = modal.classList[0];
        closeModal(modalId);
      }
    });
  });


  document.querySelectorAll('.accessory-product-card').forEach(card => {
    card.addEventListener('click', event => {
      if (event.target.classList.contains('acc__product-image') ||
        event.target.classList.contains('acc__product-title')) {
        card.click();
      }
    });
  });


  function getSelectedThumbnailAttributes(element) {

    // Find the `.thumbnail__item.selected` inside the provided element
    const selectedThumbnailItem = element.querySelector('.thumbnail__item.selected');

    // If found, extract the required attributes
    if (selectedThumbnailItem) {

      // Get the values of the necessary attributes
      const variantImageUrl = selectedThumbnailItem.getAttribute('variant-imageurl');
      const productTitle = selectedThumbnailItem.getAttribute('product-title');
      var variantSize = selectedThumbnailItem.getAttribute('variant-size');
      var variantColor = selectedThumbnailItem.getAttribute('variant-color');

      // Update sibling elements with corresponding values
      const imagePreview = element.parentElement.querySelector('#image-preview');
      const colorPreview = element.parentElement.querySelector('#color-preview');
      const sizePreview = element.parentElement.querySelector('#size-preview');


      if (variantColor == "" || !variantColor) {
        variantColor = productTitle;
      }

      if (imagePreview) imagePreview.src = variantImageUrl;

      if (variantSize == variantColor) {
        colorPreview.textContent = productTitle;
      } else {
        colorPreview.textContent = variantColor;
      }

      if (sizePreview) {
        sizePreview.classList.remove('d-none'); // Ensure it's visible
        sizePreview.textContent = variantSize;
      }
    }
  }
  // First Cup
  function step2filterColorThumbnails(productId) {

    const colorThumbnails = document.querySelectorAll('#step-2 .color-thumbnails');
    const stepElement = document.querySelector('#step-2.step-slide');


    colorThumbnails.forEach((thumbnail) => {
     if (thumbnail && thumbnail.querySelectorAll('.thumbnail__item').length > 0) {
        thumbnail.querySelector('.thumbnail__item').classList.add('selected');
        thumbnail.classList.remove('active');

        if (thumbnail.getAttribute('product-id') === productId) {
          thumbnail.classList.add('active');
          stepElement.querySelector('#image-preview').src = thumbnail.querySelector('.thumbnail__item.selected').getAttribute('variant-imageurl');

          thumbnail.querySelector('.thumbnail__item.selected').click();

          const variantOptions = thumbnail.querySelectorAll('.variant-option');
          if (variantOptions.length > 0) {
            variantOptions[0].click();
          }
        }
      }
    });

    const notices = document.querySelectorAll('#step-2 .product-notice');
    notices.forEach((notice) => {
      notice.classList.add('d-none');
      if (notice.getAttribute('data-product-id') == productId) {
        notice.classList.remove('d-none');
      }
    });

    getSelectedThumbnailAttributes(document.querySelector('#step-2 .color-thumbnails.active'));
  }
  // Second Cup
  function step4filterColorThumbnails(productId) {

    const colorThumbnails = document.querySelectorAll('#step-4 .color-thumbnails');
    const stepElement = document.querySelector('#step-4.step-slide');

    colorThumbnails.forEach((thumbnail) => {
      if (thumbnail && thumbnail.querySelectorAll('.thumbnail__item').length > 0) {
        thumbnail.querySelector('.thumbnail__item').classList.add('selected');
        thumbnail.classList.remove('active');
        if (thumbnail.getAttribute('product-id') === productId) {
          thumbnail.classList.add('active');
          stepElement.querySelector('#image-preview').src = thumbnail.querySelector('.thumbnail__item.selected').getAttribute('variant-imageurl');
          thumbnail.querySelector('.thumbnail__item.selected').click();


          const variantOptions = thumbnail.querySelectorAll('.variant-option');
          if (variantOptions.length > 0) {
            variantOptions[0].click();
          }


        }
      }
    });

    const notices = document.querySelectorAll('#step-4 .product-notice');
    notices.forEach((notice) => {
      notice.classList.add('d-none');
      if (notice.getAttribute('data-product-id') == productId) {
        notice.classList.remove('d-none');
      }
    });
    getSelectedThumbnailAttributes(document.querySelector('#step-4 .color-thumbnails.active'));
  }
  // Accessories
  function step6filterColorThumbnails(productId, action) {

    const colorThumbnails = document.querySelectorAll('#step-6 .color-thumbnails');
    const stepElement = document.querySelector('#step-6.step-slide');

    colorThumbnails.forEach((thumbnail) => {
      // thumbnail.querySelector('.thumbnail__item').classList.add('selected');

      if (thumbnail.getAttribute('product-id') === productId) {
        if (action == 'add') {
          thumbnail.querySelector('.thumbnail__item').classList.add('selected');
          thumbnail.classList.remove('d-none');
          thumbnail.classList.add('active');
          stepElement.querySelector('#image-preview').src = thumbnail.querySelector('.thumbnail__item.selected').getAttribute('variant-imageurl');
          thumbnail.querySelector('.thumbnail__item.selected').click();


          const variantOptions = thumbnail.querySelectorAll('.thumbnail__item');
          if (variantOptions.length > 0) {
            setTimeout(() => {
              variantOptions[0].click();
            }, 500);
          }
          // const varID = thumbnail.querySelector('.thumbnail__item.selected').getAttribute('variant-id');
          // selectedProducts.accessories.add(varID);

        } else if (action == 'delete') {
          thumbnail.classList.remove('active');
          // selectedProducts.accessories.delete(varID);

        }

      }
    });

    const notices = document.querySelectorAll('#step-4 .product-notice');
    notices.forEach((notice) => {
      notice.classList.add('d-none');
      if (notice.getAttribute('data-product-id') == productId) {
        notice.classList.remove('d-none');
      }
    });
    // getSelectedThumbnailAttributes(document.querySelector('#step-6 .color-thumbnails.active'));
  }

  let products = [];
  let productsData = [];
  let selectedVariant = null;
  let activeProduct = null;
  let stepCount = 1;

  let selectedProducts = {};

  // let selectedProducts = {
  //   firstProduct: createProduct(),
  //   secondProduct: createProduct(),
  //   accessories: new Set(),
  // };

  const productCards = document.querySelectorAll('.wizard .product-card');
  const thumbnails = document.querySelectorAll('.color-thumbnails');
  const slides = document.querySelectorAll('.wizard .step-slide');
  const buttonNext = document.getElementById('btn-next');
  const buttonBack = document.getElementById('btn-back');
  const buttonSkip = document.getElementById('btn-skip');

  document.addEventListener('click', handleButtonClick);

  function initializeData() {
    productCards.forEach(async (card) => {
      const handle = card.getAttribute('data-handle');
      if (handle) await fetchProduct(handle);
    });

    window.products = products;
  }

  function handleButtonClick(e) {
    if (e.target.matches('#btn-select')) handleSelectCard(e.target);
    if (e.target.matches('#btn-select-accessory')) handleSelectAccessoryCard(e.target);
    if (e.target.matches('#btn-next')) handleNextStep();
    if (e.target.matches('#btn-back')) handlePreviousStep();
    if (e.target.matches('#btn-skip')) handleSkipStep();
    if (e.target.matches('#edit_button')) handleEditButton(e.target);
    if (e.target.matches('.accessory-product-card')) handleSelectAccessory(e.target);
    // if (e.target.matches('#btn-select-accessory')) handleSelectAccessory(e.target);
    if (e.target.matches('#deleteItem')) handleDeleteItem(e.target);
    if (e.target.matches('#deleteItem svg')) handleDeleteItem(e.target);
    if (e.target.matches('#btn-reset-wizard')) handleResetWizard();
    if (e.target.matches('#add_more_accessories')) handleAddMoreAccessories();
    if (e.target.matches('#add_second_cup')) handleAddSecondCup();
    if (e.target.matches('#add_first_cup')) handleAddFirstCup();
  }
  function handleAddSecondCup() {
    document.querySelector("#step-7").classList.add("d-none");
    document.querySelector(".wizard-container").classList.remove("d-none");
    document.querySelector(".wizard__hero").removeAttribute("style");

    stepCount = 3;
    
    var steps = document.querySelectorAll("#wizard .step-slide");

    if (steps.length > 0) {
      steps[2].classList.add("active");
    }
    
    toggleUSPcontent();
  }
  function handleAddFirstCup() {
    document.querySelector("#step-7").classList.add("d-none");
    document.querySelector(".wizard-container").classList.remove("d-none");
    document.querySelector(".wizard__hero").removeAttribute("style");

    stepCount = 1;
    
    var steps = document.querySelectorAll("#wizard .step-slide");

    if (steps.length > 0) {
      steps[0].classList.add("active");
    }
    
    toggleUSPcontent();
  }

  function handleAddMoreAccessories() {
    document.querySelector("#step-7").classList.add("d-none");
    document.querySelector(".wizard-container").classList.remove("d-none");
    document.querySelector(".wizard__hero").removeAttribute("style");

    stepCount = 5;
    
    var steps = document.querySelectorAll("#wizard .step-slide");

    if (steps.length > 0) {
      steps[4].classList.add("active");
    }
    
    toggleUSPcontent();
  }

  function removeTextContent(selector) {
    // Select all elements matching the selector
    const elements = document.querySelectorAll(selector);

    // Iterate through each element and remove its text content
    elements.forEach(element => {
        element.textContent = ""; // Set textContent to an empty string
    });
}

  function handleResetWizard() {
    stepCount = 1;

    let selectedProducts = {};
    removeTextContent(".selected-product-wrapper #variant-color");
    removeTextContent(".selected-product-wrapper #variant-size");
    removeTextContent(".selected-product-wrapper #variant-price");

    removeTextContent(".selected-product-wrapper #accessory-colour");
    removeTextContent(".selected-product-wrapper #accessory-size");
    removeTextContent(".selected-product-wrapper #accessory-price");

    // Select all elements with the class 'step-slide' inside the #wizard
    document.querySelector(".wizard-container").classList.remove("d-none");
    document.querySelector(".wizard__hero").removeAttribute("style");


    document.querySelector("#step-7").classList.add("d-none");

    var steps = document.querySelectorAll("#wizard .step-slide");
    var product_card = document.querySelectorAll(".product-card");
    var thumbnail_item = document.querySelectorAll(".thumbnail__item");
    var selected_product_card = document.querySelectorAll(".selected-product-card:not(.accessories)");
    var selected_product_card_accessories = document.querySelectorAll(".selected-product-card.accessories:not(.do-not-remove)");
    var accessory_product_card = document.querySelectorAll(".accessory-product-card");

    // Loop through all elements and remove the 'active' class
    steps.forEach(item => {
      item.classList.remove("active");
    });
    accessory_product_card.forEach(item => {
      item.classList.remove("selected");
      item.classList.remove("active");
    });
    selected_product_card.forEach(item => {
      item.classList.add("d-none");
    });
    selected_product_card_accessories.forEach(item => {
      item.remove();
    });
    thumbnail_item.forEach(item => {
      item.classList.remove("selected");
    });
    product_card.forEach(item => {
      item.classList.remove("active");
    });

    // Add the 'active' class to the first element
    if (steps.length > 0) {
      steps[0].classList.add("active");
    }
    toggleUSPcontent();

  }
  function removeh3titles() {
    document.querySelectorAll('#step-7 .h3-title:not(.do-not-remove)').forEach(title => {
      // Check if the next sibling element is a div with the class 'selected-cup'
      if (title.nextElementSibling && title.nextElementSibling.classList.contains('selected-cup')) {
        title.style.display = 'block'; // Make it visible
      } else {
        title.style.display = 'none'; // Hide it
      }
    });
  }
  function handleDeleteItem(target) {
    const selectedCup = target.closest('.selected-cup');
    const variantId = selectedCup.getAttribute('id');
    if (selectedCup) {
      selectedCup.remove();
      var selectedProductItem = document.querySelector(`.selected-product-card[data-variant-id="${variantId}"]`);
      if(selectedProductItem.getAttribute("id") == "selected-product-card-1"){
        document.querySelector("#add_first_cup").classList.remove('d-none');
      }
      if(selectedProductItem.getAttribute("id") == "selected-product-card-2"){
        document.querySelector("#add_second_cup").classList.remove('d-none');
      }
      if(selectedProductItem.classList.contains("accessories")){
        selectedProductItem.remove();
      }else{
        selectedProductItem.setAttribute("data-variant-id","");
        selectedProductItem.querySelector("#product-title").textContent = "";
        selectedProductItem.querySelector("#variant-color").textContent = "";
        selectedProductItem.querySelector("#variant-size").textContent = "";
        selectedProductItem.querySelector("#variant-price").textContent = "";
      }
      removeh3titles();
      delete selectedProducts[variantId];
      

      var selectedProductDetails = getSelectedProductDetails();
      var totalData = calculateTotalData(selectedProductDetails);
      updateTotalValues(totalData);
      createAddToCartUrl(selectedProductDetails);
      console.log(selectedProductDetails.length == 0);
      if (selectedProductDetails.length == 0) {
        document.querySelector("#add_more_accessories").classList.add('d-none');
      }else{
        document.querySelector("#add_more_accessories").classList.remove('d-none');
      }
      console.log(selectedProductDetails.card1.variantId == "" && selectedProductDetails.card2.variantId == "");
      if (selectedProductDetails.card1.variantId == "" && selectedProductDetails.card2.variantId == "") {
        document.querySelector("#btn-add-to-cart").setAttribute('disabled',true);
      } else {
        document.querySelector("#btn-add-to-cart").removeAttribute('disabled');
      }

      


    }

  }





  function handleNextStep() {
    stepCount++;
    updateStepUI();
    executeStepLogic();
  }

  function handlePreviousStep(step) {
    if (stepCount == 5) {
      stepCount = 3;
    } else {
      stepCount--;
    }
    updateStepUI();
  }

  function handleEditButton(button) {
    var btnstep = button.getAttribute('step_number');
    stepCount = btnstep;
    var steps = document.querySelectorAll("#wizard .step-slide");
    
    steps.forEach(item => {
      item.classList.remove("active");
    });

    var selector = "#step-"+btnstep+".step-slide";
    document.querySelector(selector).classList.add("active");
    setTimeout(() => {
      document.querySelector(selector).scrollIntoView({ behavior: "smooth", block: "center" });
    }, 1000);
    toggleUSPcontent();
  }

  function handleSkipStep() {

    

    if (stepCount == 3) {
      stepCount = 5;
    }  else {
      if (stepCount == 5) {
        stepCount = 7;
      }else{
        stepCount++;
      }
    }
    console.log(stepCount);
    updateStepUI();
    executeStepLogic();
  }

  // final step
  function displaySelectedCups(selectedProductDetails) {
    // Select the container where the cups will be displayed
    const selectedCupsWrapper = document.querySelector('.selected-cups-wrapper');

    // Clear existing cups if needed
    selectedCupsWrapper.innerHTML = '';

    // Function to create a cup element from product details
    function createCupElement(cupDetails) {

      // Create a new div for the selected cup
      const cupElement = document.createElement('div');
      cupElement.classList.add('selected-cup');
      cupElement.classList.add(cupDetails.type);
      cupElement.setAttribute("id", cupDetails.variantId);

      // Set the inner HTML of the cup element with the details
      cupElement.innerHTML = `
        <img src="${cupDetails.image}" alt="${cupDetails.title}">
        <div class="cup-details">
          <h4 class="cup-title">${cupDetails.title}</h4>
          <div class="cup-specs">
            <p class="thumbnail__title">Colour: <span id="cup-color">${cupDetails.color}</span></p>
            <p class="thumbnail__title">Price: <span id="cup-price">${cupDetails.price}</span></p>
            <p class="thumbnail__title">Size: <span id="cup-size">${cupDetails.size}</span></p>
            <p class="thumbnail__title star-rating"><span id="variant-rating">4.8 <svg width="93" height="16" viewBox="0 0 93 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.636 15.306L5.562 9.582L0.918 6.468H6.606L8.64 0.329999L10.71 6.468H16.362L11.718 9.582L13.68 15.306L8.64 11.652L3.636 15.306ZM22.7153 15.306L24.6413 9.582L19.9973 6.468H25.6853L27.7193 0.329999L29.7893 6.468H35.4413L30.7973 9.582L32.7593 15.306L27.7193 11.652L22.7153 15.306ZM41.7946 15.306L43.7206 9.582L39.0766 6.468H44.7646L46.7986 0.329999L48.8686 6.468H54.5206L49.8766 9.582L51.8386 15.306L46.7986 11.652L41.7946 15.306ZM60.8739 15.306L62.7999 9.582L58.1559 6.468H63.8439L65.8779 0.329999L67.9479 6.468H73.5999L68.9559 9.582L70.9179 15.306L65.8779 11.652L60.8739 15.306ZM79.9532 15.306L81.8792 9.582L77.2352 6.468H82.9232L84.9572 0.329999L87.0272 6.468H92.6792L88.0352 9.582L89.9972 15.306L84.9572 11.652L79.9532 15.306Z" fill="#FFB74A"/>
</svg>
</span></p>
          </div>
        </div>
        <button id="deleteItem">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" stroke="#DC5E40"/>
          <path d="M21.5 11H19V10.5C19 10.1022 18.842 9.72064 18.5607 9.43934C18.2794 9.15804 17.8978 9 17.5 9H14.5C14.1022 9 13.7206 9.15804 13.4393 9.43934C13.158 9.72064 13 10.1022 13 10.5V11H10.5C10.3674 11 10.2402 11.0527 10.1464 11.1464C10.0527 11.2402 10 11.3674 10 11.5C10 11.6326 10.0527 11.7598 10.1464 11.8536C10.2402 11.9473 10.3674 12 10.5 12H11V21C11 21.2652 11.1054 21.5196 11.2929 21.7071C11.4804 21.8946 11.7348 22 12 22H20C20.2652 22 20.5196 21.8946 20.7071 21.7071C20.8946 21.5196 21 21.2652 21 21V12H21.5C21.6326 12 21.7598 11.9473 21.8536 11.8536C21.9473 11.7598 22 11.6326 22 11.5C22 11.3674 21.9473 11.2402 21.8536 11.1464C21.7598 11.0527 21.6326 11 21.5 11ZM14 10.5C14 10.3674 14.0527 10.2402 14.1464 10.1464C14.2402 10.0527 14.3674 10 14.5 10H17.5C17.6326 10 17.7598 10.0527 17.8536 10.1464C17.9473 10.2402 18 10.3674 18 10.5V11H14V10.5ZM20 21H12V12H20V21ZM15 14.5V18.5C15 18.6326 14.9473 18.7598 14.8536 18.8536C14.7598 18.9473 14.6326 19 14.5 19C14.3674 19 14.2402 18.9473 14.1464 18.8536C14.0527 18.7598 14 18.6326 14 18.5V14.5C14 14.3674 14.0527 14.2402 14.1464 14.1464C14.2402 14.0527 14.3674 14 14.5 14C14.6326 14 14.7598 14.0527 14.8536 14.1464C14.9473 14.2402 15 14.3674 15 14.5ZM18 14.5V18.5C18 18.6326 17.9473 18.7598 17.8536 18.8536C17.7598 18.9473 17.6326 19 17.5 19C17.3674 19 17.2402 18.9473 17.1464 18.8536C17.0527 18.7598 17 18.6326 17 18.5V14.5C17 14.3674 17.0527 14.2402 17.1464 14.1464C17.2402 14.0527 17.3674 14 17.5 14C17.6326 14 17.7598 14.0527 17.8536 14.1464C17.9473 14.2402 18 14.3674 18 14.5Z" fill="#DC5E40"/>
          </svg>
        </button>
        
      `;

      return cupElement;
    }

    // Loop through selected products and create cup elements
    const headingElement = document.createElement('h3');
    headingElement.classList.add('h3-title');
    headingElement.classList.add('selected-cups-heading');
    headingElement.textContent = 'Cups';
    selectedCupsWrapper.appendChild(headingElement);
    
    console.log(selectedProductDetails);
    if (selectedProductDetails.card1.variantId !== "") {
      selectedCupsWrapper.appendChild(createCupElement(selectedProductDetails.card1));
      document.querySelector('#add_first_cup').classList.add('d-none');
    }else{
      document.querySelector('#add_first_cup').classList.remove('d-none');
    }
    if (selectedProductDetails.card2.variantId !== "") {
      selectedCupsWrapper.appendChild(createCupElement(selectedProductDetails.card2));
      document.querySelector('#add_second_cup').classList.add('d-none');

    }else{
      document.querySelector('#add_second_cup').classList.remove('d-none');
      // const cupButton = document.createElement('button');
      // cupButton.id = "add_second_cup";
      // cupButton.className = "card-button-inverted";
      // cupButton.textContent = "Add 2nd Cup";

      // selectedCupsWrapper.appendChild(cupButton);
    }
 
    if (selectedProductDetails.accessories.length > 0) {
      // Create a heading element
      const headingElement = document.createElement('h3');
      headingElement.classList.add('h3-title');
      headingElement.classList.add('selected-accessories-heading');
      headingElement.textContent = 'Accessories';

      // Append the heading to the selectedCupsWrapper
      selectedCupsWrapper.appendChild(headingElement);
    }
    selectedProductDetails.accessories.forEach(accessory => {
      // Create a fake cup detail for accessories
      const accessoryDetails = {
        variantId: accessory.variantId || 'null', // Set a default image if none exists
        image: accessory.image || 'default-image.jpg', // Set a default image if none exists
        title: accessory.title || 'Accessory', // Fallback title
        color: accessory.color || 'N/A', // Fallback color
        price: accessory.price || 'N/A', // Fallback price
        size: accessory.size || 'N/A', // Fallback size
        rating: 'N/A',
        type: 'accessories' // Set a default rating if not applicable
      };
      selectedCupsWrapper.appendChild(createCupElement(accessoryDetails));
    });

  }

  function createAddToCartUrl(selectedProductDetails) {
    const baseUrl = "https://sttoke.com/cart/";
    let url = baseUrl;

    // Helper function to add variant ID and quantity to the URL string
    function addVariantToUrl(variantId, qty = 1) {
      if (variantId) {
        url += `${variantId}:${qty},`;
      }
    }

    // Add variant IDs from card1 and card2
    if (selectedProductDetails.card1) {
      addVariantToUrl(selectedProductDetails.card1.variantId);
    }
    if (selectedProductDetails.card2) {
      addVariantToUrl(selectedProductDetails.card2.variantId);
    }

    // Add variant IDs from accessories
    if (Array.isArray(selectedProductDetails.accessories)) {
      selectedProductDetails.accessories.forEach(accessory => {
        addVariantToUrl(accessory.variantId);
      });
    }

    // Remove the trailing comma
    url = url.replace(/,$/, "");

    // Set the href of #btn-add-to-cart
    const btnAddToCart = document.getElementById('btn-add-to-cart');
    if (btnAddToCart) {
      btnAddToCart.href = url;
    }
  }

  function calculateTotalData(selectedProductDetails) {
    console.log(selectedProducts);
    // Helper function to parse price strings
    function parsePrice(priceString) {
      return parseFloat(priceString.replace('$', '').replace('USD', '').trim()) || 0;
    }

    // Calculate subtotal by summing the prices of card1, card2, and accessories
    let subtotal = 0;

    if (selectedProductDetails.card1 && selectedProductDetails.card1.price) {
      subtotal += parsePrice(selectedProductDetails.card1.price);
    }

    if (selectedProductDetails.card2 && selectedProductDetails.card2.price) {
      subtotal += parsePrice(selectedProductDetails.card2.price);
    }

    if (Array.isArray(selectedProductDetails.accessories)) {
      selectedProductDetails.accessories.forEach(accessory => {
        if (accessory.price) {
          subtotal += parsePrice(accessory.price);
        }
      });
    }

    // Define shipping and discount values (assuming shipping is $0 and discount is $10.5 as per provided data)
    const shipping = 0;
    const discount = 0;

    // Calculate total after applying discount
    const total = subtotal - discount;

    // Create the totalData object
    const totalData = {
      subtotal: subtotal.toFixed(2),
      shipping: shipping.toFixed(2),
      discount: discount.toFixed(2),
      total: total.toFixed(2)
    };

    return totalData;
  }

  function executeStepLogic() {
    if (stepCount === 2) {
      updateSelectedProductDetails();
    }

    if (stepCount === 3) {
      buttonSkip.removeAttribute("disabled");
    }

    if (stepCount == 4) {
      buttonSkip.classList.add('d-none');
    }

    if (stepCount == 5) {
      

      buttonSkip.classList.remove('d-none');
      buttonSkip.removeAttribute("disabled");
    }

    if (stepCount == 7) {
     

      document.querySelector('.wizard-container.section').classList.add('d-none');
      document.querySelector('#step-7').classList.remove('d-none');

      const selectedProductDetails = getSelectedProductDetails();
      displaySelectedCups(selectedProductDetails);

      const totalData = calculateTotalData(selectedProductDetails);
      updateTotalValues(totalData);
      createAddToCartUrl(selectedProductDetails);

      document.querySelector("#btn-add-to-cart").removeAttribute('disabled');
      document.querySelector("#add_more_accessories").classList.remove('d-none');
      
      checkSelectedAccessoriesCount();

    }
  }

  function checkSelectedAccessoriesCount(){
      var accessoryProductCards = document.querySelectorAll('#step-5 .accessory-product-card');
      var selectedAccessoryProductCards = document.querySelectorAll('#step-7 .selected-cup.accessories');
    
      if(selectedAccessoryProductCards.length == accessoryProductCards.length){
        document.querySelector("#add_more_accessories").classList.add('d-none');
      } else if(selectedAccessoryProductCards.length < accessoryProductCards.length){
        document.querySelector("#add_more_accessories").classList.remove('d-none');
      } 
      
  }
  function updateSelectedProductDetails() {
    const cardItem = document.getElementById('selected-product-card');

    if (cardItem && selectedVariant) {
      cardItem.setAttribute('variant-id', selectedVariant);
      cardItem.querySelector('#product-title').textContent = activeProduct.title;
    }
  }

  function handleSelectCard(button) {
    var stepID;
    var productId;
    var productCard;
    // handle select button on modal popup
    if (button.hasAttribute('data-micromodal-close')) {
      stepID = button.getAttribute('data-step');
      productId = button.getAttribute('product-id');
      productCard = document.querySelector('#step-' + stepID + '.step-slide .product-card[data-id="' + productId + '"]');
    } else {
      productCard = button.closest('.product-card');
      stepID = productCard.getAttribute('data-step');
      productId = productCard.getAttribute('data-id');
    }

    var container = productCard.closest('.product-container');
    
    for (const child of container.children) {
      child.classList.remove('active');
    }

    

    productCard.classList.add('active');
    productCard.querySelector("#btn-select").click();
    updateSelectedProduct(productCard, productId, stepID);
    buttonNext.removeAttribute('disabled');

    buttonSkip.setAttribute("disabled", true);

  }
  function handleSelectAccessoryCard(button) {
    var product_id = button.getAttribute('product-id');
    var container = document.querySelector('#step-5 .accessory-product-card[product-id="'+ product_id + '"]');
    
    container.click();
  }

  function updateSelectedProduct(el, id, step) {
    if (step == '1') {
      step2filterColorThumbnails(id);
    } else if (step == '2') {
      step4filterColorThumbnails(id);
    }
  }

  function updateSelectedProductCard(data) {
    // Validate input
    var stepId = data.stepId;
    var textContent = data.textContent;
    var cardNumber = data.cardNumber;
    var productTitle = data.productTitle;
    var imageUrl = data.imageUrl;
    var productTitle = data.productTitle;
    var variantColor = data.variantColor;
    var variantSize = data.variantSize;
    var variantPrice = data.variantPrice;
    var variantId = data.variantId;


    // Construct the ID for the selected product card
    const cardId = `selected-product-card-${cardNumber}`;
    const selectedCard = document.getElementById(cardId);

    // Ensure the card exists
    if (!selectedCard) {
      console.error(`Element with ID ${cardId} not found.`);
      return;
    }

    // Update the data attributes
    selectedCard.setAttribute('data-variant-id', variantId);

    // Update the inner text and image
    selectedCard.querySelector('#product-title').textContent = productTitle;
    selectedCard.querySelector('.selected__item-image').src = imageUrl;
    if (variantColor == variantSize || !variantColor || variantColor == "") {
      selectedCard.querySelector('#variant-color').textContent = productTitle;
    } else {
      selectedCard.querySelector('#variant-color').textContent = variantColor;
    }
    selectedCard.querySelector('#variant-size').textContent = variantSize;
    selectedCard.querySelector('#variant-price').textContent = variantPrice;

    // Optional: Show the card if it is hidden
    selectedCard.classList.remove('d-none');
  }

  function updateSelectedProductCardAccessories(data) {


    // Validate input
    var productId = data.productId;
    var textContent = data.textContent;
    var cardNumber = data.cardNumber;
    var productTitle = data.productTitle;
    var imageUrl = data.imageUrl;
    var productTitle = data.productTitle;
    var variantColor = data.variantColor;
    var variantSize = data.variantSize;
    var variantPrice = data.variantPrice;
    var variantId = data.variantId;


    // Construct the ID for the selected product card
    var cardId = "#accessory-" + productId + "";
    var selectedCard = document.querySelector(cardId);


    if (selectedCard) {
      // Update the data attributes
      if (variantId) {
        selectedCard.setAttribute('data-variant-id', variantId);
      }

      // Update the inner text and image
      selectedCard.querySelector('#product-title').textContent = productTitle;
      selectedCard.querySelector('.selected__item-image').src = imageUrl;
      document.querySelector('#step-6 #image-preview').src = imageUrl;

      if (variantColor == variantSize || variantColor == "") {
        selectedCard.querySelector('#accessory-colour').textContent = productTitle;

        document.querySelector('#step-6 #color-preview').textContent = productTitle;

      } else {
        selectedCard.querySelector('#accessory-colour').textContent = variantColor;

        document.querySelector('#step-6 #color-preview').textContent = variantColor;

      }
      selectedCard.querySelector('#accessory-size').textContent = variantSize;
        document.querySelector('#step-6 #size-preview').textContent = variantSize;
      
      selectedCard.querySelector('#accessory-price').textContent = variantPrice;

      // Optional: Show the card if it is hidden
      selectedCard.classList.remove('d-none');
    }
  }

  function handleSelectAccessory(target) {

    if (target.getAttribute('id') == "btn-select-accessory") {
      const parentAccessoryCard = target.closest(".accessory-product-card");
      parentAccessoryCard.click();
      return;
    }
    const productId = target.getAttribute('product-id');
    const variantId = target.getAttribute('variant-id');
    const stepId = target.getAttribute('step-id');
    if (target.classList.contains('active')) {
      target.classList.remove('active');
      step6filterColorThumbnails(productId, 'delete');

    } else {
      target.classList.add('active');
      step6filterColorThumbnails(productId, 'add');
    }

    const accessoryTitle = target.querySelector(".acc__product-title").textContent;
    const accessoryImage = target.querySelector(".acc__product-image").getAttribute("src");
    const accessoryPrice = target.getAttribute("data-price");

    if (target.classList.contains('active')) {
      const accessory = {
        id: productId,
        image: accessoryImage,
        title: accessoryTitle,
        price: accessoryPrice,
        color: " ",
        size: " "
      };
      addAccessoriesToCard([accessory]);
      addProductToSelectedProductsObject(variantId, accessoryPrice, "accessories");
      buttonSkip.setAttribute("disabled", true);
    } else {

      removeAccessoryFromCard(productId);

      delete selectedProducts[variantId];

    }

    buttonSkip.disabled = containsProduct("accessories");
    buttonNext.disabled = !containsProduct("accessories");

  }

  function containsProduct(productType) {
    var producttypestring = "" + productType + "";

    for (const key in selectedProducts) {
      console.log(selectedProducts[key]);
      console.log(selectedProducts[key].type == producttypestring);
      if (selectedProducts[key].type == producttypestring) {
        return true; // Found the type
      }
    }
    return false; // Not found 
  }

  // function containsProduct(productType) {
  //   for (var key in selectedProducts) {
  //       if (selectedProducts[key].type == productType) {
  //           return true; 
  //       }
  //   }
  //   return false; 
  // } 

  function removeAccessoryFromCard(id) {
    document.querySelector(`#accessory-${id}`).remove();
  }


  function addAccessoriesToCard(accessories) {
    const selectedAccessoriesCard = document.querySelector('#selected-accessories-card');
    // Clear existing accessories if needed
    accessories.forEach(accessory => {
      // Clone the template element
      const accessoryTemplate = selectedAccessoriesCard.cloneNode(true);

      accessoryTemplate.setAttribute('id', 'accessory-' + accessory.id);
      // accessory-product ID
      accessoryTemplate.setAttribute('data-variant-id', accessory.id);

      accessoryTemplate.classList.remove('d-none');
      accessoryTemplate.classList.remove('do-not-remove');


      // Update the image, title, and price based on the accessory object
      const imageElement = accessoryTemplate.querySelector('.selected__item-image');
      const titleElement = accessoryTemplate.querySelector('.selected__description #product-title');
      const priceElement = accessoryTemplate.querySelector('.selected__description #accessory-price');
      const colorElement = accessoryTemplate.querySelector('.selected__description #accessory-colour');
      const sizeElement = accessoryTemplate.querySelector('.selected__description #accessory-size');

      if (imageElement) imageElement.src = accessory.image;
      if (titleElement) titleElement.textContent = accessory.title;
      if (priceElement) priceElement.textContent = accessory.price;
      if (colorElement) colorElement.textContent = "";
      if (sizeElement) sizeElement.textContent = "";

      // Append the updated accessory element to the card container
      selectedAccessoriesCard.parentElement.appendChild(accessoryTemplate);
    });
  }

  function updateStepUI() {
    updateSlides();
    updateProgressBar();
    toggleUSPcontent();
  }

  function updateSlides() {
    document.querySelectorAll('[step]').forEach((el) => el.setAttribute('step', stepCount));
    slides.forEach((slide, index) => slide.classList.toggle('active', index + 1 === stepCount));
    buttonSkip.classList.toggle('active', stepCount >= 3 && stepCount < 6);
    
    buttonNext.disabled = (stepCount == 5 || stepCount == 3); 
    
  }

  function toggleUSPcontent() {
    const uspEl = document.querySelector('.wizard__hero');
    if (stepCount > 1) {
      uspEl.setAttribute('hiddenElement', true);
      $(uspEl).slideUp();
    } else {
      uspEl.removeAttribute('hiddenElement');
      $(uspEl).slideDown();
    }
  }

  function updateProgressBar() {
    const slidesLength = slides.length;
    const progressWidth = document.querySelector('.progress-bar-width');
    progressWidth.style.width = `${(stepCount / slidesLength) * 100}%`;
  }

  function handleSelectColorVariant(event) {

    const thumbnail = event.currentTarget;
    const variantId = thumbnail.getAttribute('variant-id');
    const productId = thumbnail.getAttribute('product-id');
    const productTitle = thumbnail.getAttribute('product-title');
    var variantColor = thumbnail.getAttribute('variant-color');
    const variantSize = thumbnail.getAttribute('variant-size');
    const variantPrice = thumbnail.getAttribute('variant-price');
    const stepId = thumbnail.getAttribute('step-id');

    const container = thumbnail.closest('.color-thumbnails');
    for (const child of container.children) {
      child.classList.remove('selected');
    }
    thumbnail.classList.add('selected');


    if (stepId == 3) {
      updateSelectedProductCardAccessories({
        cardNumber: stepId,
        productId: productId,
        variantId: variantId,
        productTitle: productTitle,
        variantColor: variantColor,
        variantSize: variantSize,
        variantPrice: variantPrice,
        imageUrl: thumbnail.getAttribute('variant-imageurl'),
      });

    } else {


      for (const child of container.children) {
        child.classList.remove('selected');
      }
      if (variantColor == "" || !variantColor) {
        variantColor = productTitle;
      }
      thumbnail.classList.add('selected');

      // Update previews
      const wrapper = container.parentElement;
      wrapper.querySelector('#image-preview').src = thumbnail.getAttribute('variant-imageurl');

      if (thumbnail.getAttribute('variant-color') == thumbnail.getAttribute('variant-size')) {
        wrapper.querySelector('#color-preview').textContent = productTitle;
      } else {
        wrapper.querySelector('#color-preview').textContent = thumbnail.getAttribute('variant-color');
      }
      wrapper.querySelector('#size-preview').textContent = thumbnail.getAttribute('variant-size');
      // Set variant values
      if (stepCount === 2) {
        addProductToSelectedProductsObject(variantId, variantPrice, "product_1");
      } else if (stepCount === 4) {
        addProductToSelectedProductsObject(variantId, variantPrice, "product_2");


      } else if (stepCount == 5) {
      }


      updateSelectedProductCard({
        cardNumber: stepId,
        variantId: variantId,
        productTitle: productTitle,
        variantColor: variantColor,
        variantSize: variantSize,
        variantPrice: variantPrice,
        imageUrl: thumbnail.getAttribute('variant-imageurl'),
      });
    }

  }

  async function fetchProduct(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

      const product = await response.json();
      if (!products.some((p) => p.id === product.id)) products.push(product);
    } catch (error) {
      console.error('Error fetching product:', error);
    }
  }

  function initializeThumbnails() {
    document.querySelectorAll('.thumbnail__item').forEach((item) => item.addEventListener('click', handleSelectColorVariant));
  }
  // function initializeAccessoryClickListener() {
  //   document.querySelectorAll('.thumbnail__item').forEach((item) => item.addEventListener('click', handleSelectColorVariant));
  // }

  function setActiveThumbnail(el, pid) {
    const currentThumbnail = Array.from(el.querySelectorAll('.color-thumbnails')).find((thumbnail) => thumbnail.classList.contains('active'));
    if (currentThumbnail) currentThumbnail.classList.remove('active');

    const targetElement = Array.from(el.querySelectorAll('.color-thumbnails')).find((thumbnail) => thumbnail.getAttribute('product-id') === pid);

    if (targetElement) {
      targetElement.classList.add('active');
      const selectedItem = targetElement.querySelector('.thumbnail__item.selected');
      document.querySelectorAll('#image-preview').forEach((img) => {
        img.src = selectedItem.getAttribute('variant-imageurl');
      });

      document.querySelectorAll('#color-preview').forEach((title) => {
        title.textContent = selectedItem.getAttribute('variant-color');
      });
    }
  }

  initializeData();
  initializeThumbnails();


  document.querySelectorAll('.product-gallery').forEach(gallery => {
    const mediaListWrapper = gallery.querySelector('.product-gallery__media-list-wrapper');
    if (mediaListWrapper) {
      const firstMedia = mediaListWrapper.querySelector('.product-gallery__media');
      if (firstMedia) {
        firstMedia.classList.add('is-selected');
      }
    }

    const thumbnailList = gallery.querySelector('.product-gallery__thumbnail-list');
    if (thumbnailList) {
      const firstThumbnail = thumbnailList.querySelector('.product-gallery__thumbnail');
      if (firstThumbnail) {
        firstThumbnail.setAttribute('aria-current', 'true');
      }
    }

  });

  document.querySelectorAll('.product-gallery__thumbnail').forEach(thumbnail => {
    thumbnail.addEventListener('click', function () {

      // Get the aria-label value
      const ariaLabel = this.getAttribute('aria-label');
      
      if (ariaLabel && ariaLabel.startsWith('Go to item ')) {
        // Extract the item number from the aria-label
        const itemNumber = parseInt(ariaLabel.replace('Go to item ', ''), 10);

        // Find the closest .product-gallery__media-list-wrapper
        const mediaListWrapper = this.closest('.product-gallery')?.querySelector('.product-gallery__media-list-wrapper');
        if (mediaListWrapper) {
          // Get all the .product-gallery__media elements
          const mediaItems = mediaListWrapper.querySelectorAll('.product-gallery__media');

          // Remove 'is-selected' from all .product-gallery__media elements
          mediaItems.forEach(media => {
            media.classList.remove('is-selected'); 
          });

          // Get the target media item based on the index
          const targetMedia = mediaItems[itemNumber - 1];
          if (targetMedia) {
            targetMedia.classList.add('is-selected');
          }
        }
      }
    });
  });

  document.querySelectorAll('.product-gallery__nav-btn').forEach(navButton => {
    navButton.addEventListener('click', function () {
      // Determine if the button is "next" or "prev"
      const isNext = this.classList.contains('product-gallery__nav-btn--next');

      // Find the closest gallery and media list wrapper
      const productGallery = this.closest('.product-gallery');
      const mediaListWrapper = productGallery?.querySelector('.product-gallery__media-list-wrapper');
      const thumbnailList = productGallery?.querySelector('.product-gallery__thumbnail-list');

      if (mediaListWrapper && thumbnailList) {
        // Get all the .product-gallery__media and .product-gallery__thumbnail elements
        const mediaItems = Array.from(mediaListWrapper.querySelectorAll('.product-gallery__media'));
        const thumbnails = Array.from(thumbnailList.querySelectorAll('.product-gallery__thumbnail'));

        // Find the currently selected media and thumbnail
        const currentIndex = mediaItems.findIndex(media => media.classList.contains('is-selected'));

        if (currentIndex !== -1) {
          // Determine the new index
          const newIndex = isNext
            ? (currentIndex + 1) % mediaItems.length   // Wrap around for "next"
            : (currentIndex - 1 + mediaItems.length) % mediaItems.length; // Wrap around for "prev"

          // Update the is-selected class for media items
          mediaItems.forEach(media => media.classList.remove('is-selected'));
          mediaItems[newIndex].classList.add('is-selected');

          // Update the aria-current attribute for thumbnails
          thumbnails.forEach(thumbnail => thumbnail.removeAttribute('aria-current'));
          thumbnails[newIndex].setAttribute('aria-current', 'true');
          thumbnails[newIndex].click();
        }
      }
    });
  });

});





